var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      staticStyle: { padding: "0px" },
      attrs: {
        id: "setting-selected-report",
        "hide-header": "",
        "hide-footer": "",
        centered: "",
      },
    },
    [
      _c("div", { staticClass: "modal-content" }, [
        _c("div", { staticClass: "modal-header" }, [
          _c("div", { staticClass: "modal-title" }, [
            _vm._v("Scrapboard report settings"),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modal-body" }, [
          _c("div", { staticClass: "setting-content-wrap" }, [
            _c("div", { staticClass: "setting-group" }, [
              _c("div", { staticClass: "group-header" }, [
                _c("strong", { staticClass: "group-title" }, [
                  _vm._v("Report Type"),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "group-body" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("select", { staticClass: "form-control custom-select" }, [
                    _c("optgroup", { attrs: { label: "Basic Report" } }, [
                      _c("option", { attrs: { value: "1-1", selected: "" } }, [
                        _vm._v("Daily Report1"),
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "1-2" } }, [
                        _vm._v("Daily Report 2"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("optgroup", { attrs: { label: "Custom Report" } }, [
                      _c("option", { attrs: { value: "2-1" } }, [
                        _vm._v("Mercedes"),
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "2-2" } }, [
                        _vm._v("Audi"),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "go-report-preview" }, [
                  _c("nav", [
                    _c("div", { staticClass: "nav nav-tabs-style-4" }, [
                      _c(
                        "button",
                        {
                          staticClass: "nav-link active",
                          attrs: {
                            "data-toggle": "tab",
                            "data-target": "#nav-home",
                            type: "button",
                          },
                        },
                        [_vm._v("Sample report")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "nav-link",
                          attrs: {
                            "data-toggle": "tab",
                            "data-target": "#nav-profile",
                            type: "button",
                          },
                        },
                        [_vm._v("Report components")]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tab-content" }, [
                    _c(
                      "div",
                      {
                        staticClass: "tab-pane fade show active",
                        attrs: { id: "nav-home" },
                      },
                      [
                        _c("div", { staticClass: "go-report-sample" }, [
                          _c("div", { staticClass: "go-object-wrap" }),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "tab-pane fade",
                        attrs: { id: "nav-profile" },
                      },
                      [
                        _c("div", { staticClass: "go-report-components" }, [
                          _c("div", { staticClass: "go-report-table" }, [
                            _c("h1", [_vm._v("Report Template Title")]),
                            _vm._v(" "),
                            _c("ol"),
                          ]),
                        ]),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "setting-group" }, [
              _c("div", { staticClass: "group-header" }, [
                _c("strong", { staticClass: "group-title" }, [
                  _vm._v("Data Source"),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "group-body" }, [
                _c("dl", { staticClass: "form-item" }, [
                  _c("dt", [
                    _c("i", { staticClass: "go-icon-discovery go-icon-28" }),
                  ]),
                  _vm._v(" "),
                  _c("dd", [
                    _c("div", { staticClass: "block-wrap" }, [
                      _c("label", [_vm._v("Discovery 문서")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "badge badge-secondary" }, [
                        _vm._v("default"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "go-info" }, [
                      _vm._v(
                        "\n                  Scrapboard을 기준으로 추천된 Discovery 문서입니다. Discovery 문서는 모든 리포트에 기본 Data source로 사용됩니다.\n                "
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("dl", { staticClass: "form-item" }, [
                  _c("dt", [
                    _c("i", { staticClass: "go-icon-scrapboard go-icon-28" }),
                  ]),
                  _vm._v(" "),
                  _c("dd", [
                    _c("div", { staticClass: "custom-control custom-switch" }, [
                      _c("input", {
                        staticClass: "custom-control-input",
                        attrs: { type: "checkbox", id: "customSwitch2" },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "custom-control-label",
                          attrs: { for: "customSwitch2" },
                        },
                        [_vm._v("Scrapboard 문서")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "go-info" }, [
                      _vm._v(
                        "Scrapboard에 있는 문서 입니다. 리포트 생성시 Scrapboard 문서 포함 여부를 설정할 수 있습니다."
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modal-footer" }, [
          _c("div", { staticClass: "go-elements" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-default",
                attrs: { type: "button", "data-dismiss": "modal" },
                on: {
                  click: function ($event) {
                    return _vm.$bvModal.hide("setting-selected-report")
                  },
                },
              },
              [_vm._v("\n          Cancel\n        ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: {
                  type: "button",
                  "data-toggle": "modal",
                  "data-target": "#modal-report-writing",
                },
              },
              [_vm._v("Save")]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }